import React, { useEffect, useState } from "react";
import ReservationModal from "./ui/ReservationModal";

/**
 * OrientationResetCheckoutHost
 *
 * Headless host that owns the Clarity Reset Session ($149) ReservationModal
 * and listens on `window` for the `am:open-orientation-reset-checkout`
 * custom event. Mount this once on any page where an Clarity Reset Session
 * CTA exists and the CTA can fire the event from anywhere in the tree
 * without needing to re-mount the modal locally — same pattern as the
 * book / blueprint checkout hosts.
 *
 * Usage:
 *   <OrientationResetCheckoutHost />
 *   ...
 *   window.dispatchEvent(new CustomEvent("am:open-orientation-reset-checkout"));
 */
const OrientationResetCheckoutHost = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("am:open-orientation-reset-checkout", handler);
    return () => {
      window.removeEventListener("am:open-orientation-reset-checkout", handler);
    };
  }, []);

  return (
    <ReservationModal
      open={open}
      onClose={() => setOpen(false)}
      product="orientation_reset"
      testIdPrefix="orientation-reset-global"
      eyebrow="Clarity Reset Session · $149"
      title="Book the Clarity Reset Session."
      description="Secure checkout via Stripe. After payment, the Calendly scheduler unlocks on the next page so you can pick a time directly."
    />
  );
};

export default OrientationResetCheckoutHost;
